export default __webpack_public_path__ + "static/media/analyticsandoptimization.253499a1.png";